import React from "react";
import "../styles/components/footer.css";
import LogoIcon from "../assets/icons/logo.svg";
import AppStoreIcon from "../assets/icons/links_icons/appstore_btn_icon.svg";
import GooglePlayIcon from "../assets/icons/links_icons/googleplay_btn_icon.svg";
import InstagramIcon from "../assets/icons/links_icons/instagram_icon.svg";
import WhatsappIcon from "../assets/icons/links_icons/whatsapp_icon.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-block">
          <img src={LogoIcon} alt="Logo" className="footer-logo" />
          <div className="footer-social-links">
            <a
              href="https://www.instagram.com/bishkekpetroleum/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={InstagramIcon}
                alt="Instagram"
                className="footer-social-link"
              />
            </a>
            <a
              href="https://wa.me/996557294949"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={WhatsappIcon}
                alt="WhatsApp"
                className="footer-social-link"
              />
            </a>
          </div>
          <div className="footer-store-links">
            <a
              href="https://apps.apple.com/kg/app/bishkek-petroleum/id1584794644"
              aria-label="Download from App Store"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={AppStoreIcon} alt="Скачать в App Store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.bishkek.petroleum&hl=ru&pli=1"
              aria-label="Download from Google Play"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={GooglePlayIcon} alt="Скачать в Google Play" />
            </a>
          </div>
          <span className="footer-copyright desktop-footer">
            © Bishkek Petroleum, 2022–2025. Все права защищены.
          </span>
        </div>

        <div className="footer-block">
          <h3 className="footer-block-title">Навигация</h3>
          <ul className="footer-links">
            <li>
              <a href="/">Главная</a>
            </li>
            <li>
              <a href="/about_company">О компании</a>
            </li>
            <li>
              <a href="/stations">Карта АЗС</a>
            </li>

            <li>
              <a href="/for_clients">Оптовым клиентам</a>
            </li>
            <li>
              <a href="/for_clients/usefull_info">Полезная информация</a>
            </li>
          </ul>
        </div>

        <div className="footer-block">
          <h3 className="footer-block-title">Клиентам</h3>
          <ul className="footer-links">
            <li>
              <a href="/stations/mini_markets">Мини маркеты</a>
            </li>
            <li>
              <a href="/government_procurements">Закупки и тендерные торги</a>
            </li>
            <li>
              <a href="/rus/about/mobile-politics">Политика конфиденциальности</a>
            </li>
          </ul>
        </div>

        <div className="footer-block contacts">
          <h3 className="footer-block-title">Контакты</h3>
          <p className="footer-contact-text">
            <span className="light-text">Горячая линия:</span> 996557294949
          </p>
          <p className="footer-contact-text">office@bpetroleum.kg</p>
          <p className="footer-contact-text">
            <span className="light-text">Офис компании:</span> +996 312 303 303
          </p>
          <p className="footer-contact-text">
            <span className="light-text">Отдел продаж:</span> +996 312 303 303
          </p>
        </div>
        <span className="footer-copyright mobile-footer">
          © Bishkek Petroleum, 2022–2025. Все права защищены.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
